
export default {
    name: "MonthPicker",
    props: {
        selectedMonths: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            show: true,
            selectedYear: null,
            years: [],
        };
    },
    created() {

        let t = this;

        let start = 2025;
        let end = (new Date()).getFullYear() + 1;

        for (let i = start; i <= end; i++) {
            let months = [];

            for (let j = 1; j <= 12; j++) {
                let month = {
                    'text': j + '月',
                    'value': j,
                    'selected': false,
                };

                if (t.selectedMonths.indexOf(i + '/' + t.pad2(j)) > -1)
                    month.selected = true;

                months.push(month);
            }
            t.years.push({
                'text': i + '年',
                'value': i,
                'selected': false,
                'months': months,
            });

        }

        t.years.forEach(year => {
            let selected = true;
            year.months.forEach(month => {
                if (!month.selected)
                    selected = false;
            });
            year.selected = selected;
        });

        t.selectedYear = t.years[0];

    },
    methods: {
        close() {
            this.show = false;
            this.$emit('input', false);
        },
        toggleYear(year) {
            year.months.forEach(month => {
                month.selected = year.selected;
            });
        },
        toggleMonth(month) {
            let selected = true;
            this.selectedYear.months.forEach(month => {
                if (!month.selected)
                    selected = false;
            });
            this.selectedYear.selected = selected;
        },
        confirmSelection() {

            let t = this;

            let arr = [];

            t.years.forEach(year => {
                year.months.forEach(month => {
                    if (month.selected)
                        arr.push(year.value + '/' + t.pad2(month.value));
                });
            });

            t.list.selectedMonths = arr;

            this.$emit("change",t.list.selectedMonths);
        },
    },
};
